import { FILTER_ACCESS_CONFIG } from "../config/filterAccess.config";

/**
 * Config-driven frontend access check for marketplace filters.
 * Note: This is UX gating only; backend must enforce access too.
 */
export function canAccessFilter(filterName, planType) {
  const rule = FILTER_ACCESS_CONFIG?.[filterName] ?? "basic";

  if (rule === "basic") return true;
  if (rule === "premium") return planType !== "basic";

  // Future-proof: unknown rule defaults to allow (avoid locking users out by mistake)
  return true;
}

